import React, { useState } from 'react';

const SNAPSHOTS_KEY = 'maptracer_snapshots';

function loadSnapshots() {
  try {
    return JSON.parse(localStorage.getItem(SNAPSHOTS_KEY) || '[]');
  } catch (e) { return []; }
}

function saveSnapshots(snapshots) {
  localStorage.setItem(SNAPSHOTS_KEY, JSON.stringify(snapshots));
}

export default function VersionSnapshotsPanel({ segments, devices, onLoad, onClose, darkMode }) {
  const [snapshots, setSnapshots] = useState(loadSnapshots);
  const [newName, setNewName] = useState('');

  const bg = darkMode ? '#1a1a2e' : '#ffffff';
  const text = darkMode ? '#e0e0e0' : '#333';
  const border = darkMode ? '#333' : '#ddd';
  const accent = '#c850c0';

  const createSnapshot = () => {
    const name = newName.trim() || `Snapshot ${snapshots.length + 1}`;
    const snapshot = {
      id: Date.now().toString(36),
      name,
      timestamp: new Date().toISOString(),
      segmentCount: (segments || []).length,
      deviceCount: (devices || []).length,
      data: { segments, devices },
    };
    const updated = [snapshot, ...snapshots].slice(0, 20); // max 20 snapshots
    setSnapshots(updated);
    saveSnapshots(updated);
    setNewName('');
  };

  const restoreSnapshot = (snapshot) => {
    if (window.confirm(`Restore "${snapshot.name}"? Current work will be replaced.`)) {
      onLoad(snapshot.data);
    }
  };

  const deleteSnapshot = (id) => {
    const updated = snapshots.filter(s => s.id !== id);
    setSnapshots(updated);
    saveSnapshots(updated);
  };

  const formatDate = (iso) => {
    try {
      const d = new Date(iso);
      return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } catch (e) { return iso; }
  };

  return (
    <div style={{
      position: 'absolute', top: 70, right: 10, width: 320, maxHeight: 'calc(100vh - 100px)',
      background: bg, border: `1px solid ${border}`, borderRadius: 8,
      boxShadow: '0 4px 20px rgba(0,0,0,0.3)', zIndex: 1000,
      display: 'flex', flexDirection: 'column', overflow: 'hidden',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', borderBottom: `1px solid ${border}` }}>
        <span style={{ fontWeight: 'bold', color: text, fontSize: 14 }}>Version Snapshots</span>
        <button onClick={onClose} style={{ background: 'none', border: 'none', color: text, cursor: 'pointer', fontSize: 18 }}>×</button>
      </div>

      {/* Create new */}
      <div style={{ padding: '10px 14px', borderBottom: `1px solid ${border}`, display: 'flex', gap: 6 }}>
        <input
          value={newName}
          onChange={e => setNewName(e.target.value)}
          placeholder="Snapshot name..."
          onKeyDown={e => e.key === 'Enter' && createSnapshot()}
          style={{
            flex: 1, padding: '6px 10px', borderRadius: 4, border: `1px solid ${border}`,
            background: darkMode ? '#16213e' : '#f8f9fa', color: text, fontSize: 12,
          }}
        />
        <button onClick={createSnapshot} style={{
          padding: '6px 12px', borderRadius: 4, border: 'none', cursor: 'pointer',
          background: accent, color: '#fff', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap',
        }}>Save</button>
      </div>

      {/* List */}
      <div style={{ overflowY: 'auto', flex: 1 }}>
        {snapshots.length === 0 && (
          <div style={{ padding: 20, textAlign: 'center', color: text, opacity: 0.5, fontSize: 12 }}>
            No snapshots yet. Save one to create a restore point.
          </div>
        )}
        {snapshots.map(snap => (
          <div key={snap.id} style={{
            padding: '10px 14px', borderBottom: `1px solid ${darkMode ? '#222' : '#f0f0f0'}`,
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: text }}>{snap.name}</div>
              <div style={{ fontSize: 10, color: text, opacity: 0.6, marginTop: 2 }}>
                {formatDate(snap.timestamp)} · {snap.segmentCount} seg · {snap.deviceCount} dev
              </div>
            </div>
            <div style={{ display: 'flex', gap: 4 }}>
              <button onClick={() => restoreSnapshot(snap)} style={{
                padding: '4px 10px', borderRadius: 4, border: `1px solid ${border}`,
                background: 'transparent', color: '#4CAF50', cursor: 'pointer', fontSize: 11, fontWeight: 600,
              }}>Restore</button>
              <button onClick={() => deleteSnapshot(snap.id)} style={{
                padding: '4px 6px', borderRadius: 4, border: `1px solid ${border}`,
                background: 'transparent', color: '#f44336', cursor: 'pointer', fontSize: 11,
              }}>×</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
